<svelte:options runes={false} />
<script>
  // Narrative strip (TASK-20260823-twap-strategies-tca PR-C2, D9): the plain-English reading of one
  // parent's scorecard — SPA-built by twapReport.narrative(), never server text. Renders nothing for
  // an empty story so the report never shows an empty band.
  export let text = '';
  export let label = 'In plain English';
</script>

{#if text}
  <div class="ns" role="note" aria-label={label}>
    <span class="ns-label">{label}</span>
    <p class="ns-text num">{text}</p>
  </div>
{/if}

<style>
  .ns { display: flex; flex-direction: column; gap: 0.2rem; padding: 0.5rem 0.7rem; border-left: 3px solid var(--color-primary, #00d4ff); background: var(--bg-secondary, #111214); border-radius: 0 var(--radius-base, 0.5rem) var(--radius-base, 0.5rem) 0; min-width: 0; }
  .ns-label { font-size: var(--font-size-xs, 0.7rem); color: var(--text-secondary, #8a8b8d); text-transform: uppercase; letter-spacing: 0.04em; }
  .ns-text { margin: 0; color: var(--text-primary, #fff); font-size: var(--font-size-sm, 0.85rem); line-height: 1.45; }
  .num { font-variant-numeric: tabular-nums; }
</style>
